import { common } from '@tencent/ceiba-base-components';

// 端外拉起app需要过滤一些参数，避免多次触发场景
const DEFAULT_FILT_PARAMS_LIST = [
  'signUp', 'getReviveByGroup', 'getReviveByInvite',
];

const filtUrlParams = (url = '', filterUrlParamsList = []) => {
  const filtList = filterUrlParamsList.length > 0 ? filterUrlParamsList : DEFAULT_FILT_PARAMS_LIST;
  // eslint-disable-next-line no-param-reassign
  url = url || window.location.href;
  const params = {};
  for (const key of filtList) {
    if (url.indexOf(key) > -1) {
      params[key] = ''; //
    }
  }
  if (Object.keys(params).length === 0) {
    console.log('filtUrlParams no need filter params and return origin url = ', url);
    return url;
  }
  const link = common.tool.setUrlParams(params, url);
  console.log('filtUrlParams  return filter url = ', link);
  return link;
};
export default filtUrlParams;
export {
  filtUrlParams,
};
